// Website Creator: htutkhaung.ko@msgtech.co.th
import { t } from './i18n.js';

export function initContact() {
  const modal = document.getElementById('consultation-modal');
  const openButtons = document.querySelectorAll('[data-open-modal]');
  const closeButtons = document.querySelectorAll('[data-close-modal]');
  const form = document.getElementById('consultation-form');
  const feedback = document.getElementById('form-feedback');

  function openModal(defaultService = '') {
    if (!modal) return;
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (defaultService && form) {
      const select = form.querySelector('#service-type');
      if (select) select.value = defaultService;
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  openButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const inlineSelect = document.getElementById('inline-solution-type');
      const service = btn.getAttribute('data-service') || (inlineSelect ? inlineSelect.value : '');
      openModal(service);
    });
  });

  // Scope chip tags inside modal
  const chips = document.querySelectorAll('#modal-scope-chips .consult-chip');
  const messageInput = document.getElementById('client-message');
  let selectedChips = new Set();

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      const chipVal = chip.getAttribute('data-chip');
      if (selectedChips.has(chipVal)) {
        selectedChips.delete(chipVal);
        chip.classList.remove('active');
      } else {
        selectedChips.add(chipVal);
        chip.classList.add('active');
      }

      // Update textarea placeholder / starter text if empty or append
      if (messageInput) {
        const chipsList = Array.from(selectedChips).join(', ');
        const existingLines = messageInput.value.split('\n').filter(l => !l.startsWith('Interested Technologies:'));
        if (selectedChips.size > 0) {
          messageInput.value = `Interested Technologies: ${chipsList}\n` + existingLines.join('\n').trim();
        } else {
          messageInput.value = existingLines.join('\n').trim();
        }
      }
    });
  });

  closeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      closeModal();
    });
  });

  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
  }

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const name = form.querySelector('#client-name')?.value;
      const email = form.querySelector('#client-email')?.value;
      const service = form.querySelector('#service-type')?.value;
      const message = form.querySelector('#client-message')?.value;

      const subject = encodeURIComponent(`[MSGTECH Consultation Inquiry] - ${service} (${name})`);
      const body = encodeURIComponent(
        `Hello MSGTECH Enterprise,\n\nI would like to discuss a project:\n\n` +
        `Name: ${name}\nEmail: ${email}\nInterested Solution: ${service}\n\nProject Scope / Requirements:\n${message}\n\n` +
        `Thank you!`
      );

      // Trigger user mail client addressed directly to info@msgtech.co.th
      window.location.href = `mailto:info@msgtech.co.th?subject=${subject}&body=${body}`;

      if (feedback) {
        feedback.style.display = 'block';
        feedback.innerHTML = `
          <div style="background: rgba(16, 185, 129, 0.12); border: 1px solid #10b981; border-radius: 12px; padding: 14px; color: #047857; font-size: 0.9rem; margin-top: 16px;">
            <div style="font-weight: 800; margin-bottom: 4px;">${t('modal.success_title')}</div>
            <div style="font-size: 0.82rem; color: #065f46;">${t('modal.success_sub')}</div>
          </div>
        `;
      }

      setTimeout(() => {
        closeModal();
        form.reset();
        if (feedback) feedback.style.display = 'none';
      }, 4000);
    });
  }
}
